import React, { useState, useEffect } from 'react';
import { Field } from 'formik';
import { CommonHash } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from '../LandingForm.module.scss';
import LandingComponentButtonForm from '../LandingComponentButtonForm';

interface ComponentFormProps {
  landing_cmp: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  index: number;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
}

const NewsletterBannerForm = ({
  landing_cmp,
  handleChange,
  setFieldValue,
  index,
}: ComponentFormProps): React.ReactElement => {
  return (
    <>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['title']`}>Banner Title</label>
        <input
          name={`landing_components[${index}].config['title']`}
          placeholder="Title"
          onChange={handleChange}
          required={true}
          defaultValue={landing_cmp.config.title || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['banner_text']`}>
          Banner description
        </label>
        <input
          name={`landing_components[${index}].config['banner_text']`}
          placeholder="Banner text"
          onChange={handleChange}
          defaultValue={landing_cmp.config.banner_text || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['button_text']`}>
          Call to action button
        </label>
        <input
          name={`landing_components[${index}].config['button_text']`}
          placeholder="Call to action button"
          onChange={handleChange}
          defaultValue={landing_cmp.config.button_text || 'Suscribe'}
          required={true}
        />
      </div>
    </>
  );
};

export default NewsletterBannerForm;
